module.exports = __webpack_public_path__ + "img/m_top_cognitive.1c0561b1.jpg";